import { getCategoryById } from '../utils/categories.js';
import { timeAgo } from '../utils/helpers.js';
import { upvoteReport } from '../services/reports.js';

/**
 * Create the HTML content for a Mapbox popup.
 */
export function createPopupHTML(report) {
  const cat = getCategoryById(report.category);

  const imgHTML = report.image_url
    ? `<img class="popup-img" src="${report.image_url}" alt="${report.title}" />`
    : '';

  return `
    ${imgHTML}
    <div class="popup-content">
      <span class="popup-category" style="background:${cat.colorLight};color:${cat.color}">
        <span class="dot" style="background:${cat.color};width:6px;height:6px;border-radius:50%;display:inline-block"></span>
        ${cat.name}
      </span>
      <div class="popup-title">${report.title}</div>
      <div class="popup-desc">${report.description}</div>
      <div class="popup-footer">
        <span>${timeAgo(report.created_at)}</span>
        <button class="popup-upvote" data-id="${report.id}">
          ▲ <span class="upvote-count">${report.upvotes || 0}</span>
        </button>
      </div>
    </div>
  `;
}

/**
 * Attach upvote handler to popup button.
 */
export function attachPopupHandlers(popup, onUpvote) {
  const el = popup.getElement();
  if (!el) return;

  const btn = el.querySelector('.popup-upvote');
  if (!btn) return;

  btn.addEventListener('click', async (e) => {
    e.stopPropagation();
    const id = btn.dataset.id;
    try {
      const updated = await upvoteReport(id);
      const countEl = btn.querySelector('.upvote-count');
      if (countEl && updated) countEl.textContent = updated.upvotes;
      btn.style.color = 'var(--accent)';
      btn.style.borderColor = 'var(--accent)';
      if (onUpvote) onUpvote(updated);
    } catch (err) {
      console.error('Upvote failed:', err);
    }
  });
}
